import { render, staticRenderFns } from "./FileDetail.vue?vue&type=template&id=f002f664"
import script from "./FileDetail.vue?vue&type=script&lang=js"
export * from "./FileDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports